import React from "react";
import "./SuccessPopup.css";
import crossImg from '../../assets/cross.png';

export default function StatusPopup({ open, onClose, statusOrderLink }: {
  open: boolean;
  onClose: () => void;
  statusOrderLink: string;
}) {
  if (!open) return null;
  return (
    <div className="success-popup-overlay" onClick={onClose}>
      <div className="status-popup-card" onClick={e => e.stopPropagation()}>
        <button className="success-popup-close" onClick={onClose} aria-label="סגור הודעה" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
          <img src={crossImg} alt="סגור" style={{ width: '30px', height: '30px' }} />
        </button>
        <div className="success-popup-header">
          <h2 className="success-popup-title">בירור סטטוס ההזמנה</h2>
        </div>
        <div className="success-popup-text">
          <span>ניתן להתעדכן בסטטוס ההזמנה בעמוד ההזמנות שלי באתר, </span>
          <a href={statusOrderLink} target="_blank" rel="noopener noreferrer" style={{ color: '#6366f1', textDecoration: 'underline' }}>לחץ כאן</a>
          <br />
          בנוסף, מיד לאחר סגירת ההזמנה, ישלח אליך מסרון המכיל לינק לצפייה בהתקדמות ההזמנה ובסטטוס הנוכחי שלה, בכל רגע נתון.
        </div>
      </div>
    </div>
  );
}
